import React, { useState } from 'react';

import DialogPortal from "Components/DialogPortal";
import ImageViewer from "Components/ImageViewer";


const Image = ({ refImg, attach }) => {
  const [showDetail, setOpenDetail] = useState(false);

  return (
    <div className="cont">
      <figure onClick={setOpenDetail.bind(null, true)}>
        <img ref={refImg} src={`${process.env.REACT_APP_FILE_API_URL}?type=1&serverfile=${attach.thumb_file}`} alt={attach.org_file} />
      </figure>
      {
        showDetail ? 
        <DialogPortal>
          <ImageViewer attach={attach} callback={setOpenDetail.bind(null, false)} />
        </DialogPortal> : null
      }
    </div>
  )
}

export default React.memo(Image);